import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequiredCourses } from "../../reduxSlices/requiredCoursesSlice";

const RequiredCourses = () => {
  const dispatch = useDispatch();
  const { courses, totals, loading, error } = useSelector(
    (state) => state.requiredCourses,
  );

  React.useEffect(() => {
    const studentId = window.localStorage.getItem("studentId");
    if (studentId) {
      dispatch(fetchRequiredCourses(studentId));
    }
  }, [dispatch]);

  const columns = [
    { key: "ses_courseidName", label: "Course" },
    { key: "ses_coursename", label: "Course Name" },
    { key: "ses_earnedcredits", label: "Earned Credits" },
    { key: "ses_gradereceived", label: "Grade Received" },
    { key: "ses_term", label: "Term" },
  ];

  const headerStyle = {
    backgroundColor: "#1976d2",
    color: "#fff",
    fontWeight: "bold",
  };

  return (
    <div
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Card style={{ width: "100%" }}>
        <CardHeader title="Completed Courses" />
        <CardContent
          style={{ height: 390, overflowY: "hidden", overflowX: "auto" }}
        >
         
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow style={{ background: "#1976d2" }}>
                  {columns.map((col) => (
                    <TableCell key={col.key} style={headerStyle}>
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ color: "red" }}
                    >
                      {error}
                    </TableCell>
                  </TableRow>
                ) : courses && courses.length > 0 ? (
                  courses.map((row, idx) => (
                    <TableRow
                      key={idx}
                      style={idx % 2 ? { background: "#f5f5f5" } : {}}
                    >
                      {columns.map((col) => (
                        <TableCell key={col.key}>
                          {row[col.key] !== null &&
                          row[col.key] !== undefined &&
                          row[col.key] !== ""
                            ? row[col.key]
                            : "-"}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No required courses found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box mb={2} mt={3} display="flex" justifyContent="flex-end">
            <Typography variant="h6">
              Total Credits Earned: {totals.earned}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default RequiredCourses;
